// extracted by mini-css-extract-plugin
export default {"mainContentContainer":"_e8d1cdde","resultsContainer":"_d2de3aa6","resultsHeader":"_be2d849e","sortContainer":"_71cb9686","paginationContainer":"_320b72b0","bottomModule":"_cc5a098e"};